import { $win, $body } from "../utils/globals";

$win.on('load', function() {
  $body.addClass('is-loaded');
})

